import { BordResponsibleUser } from '../../../../../../components/NudosComponents';
import useUsersState from '../../../../../../state/useUsersState';
import { IbackofficeUserData } from '../../../../../../types/configuration.types';
import { IResponsibleUserData } from '../../../../../../types/responsibleUser.types';
import { IlogisticServiceDetails } from '../../../../../../types/services';
import './LogisticServiceRequesterInformation.scss';

const LogisticServiceRequesterInformation = ({
  logisticServiceData,
  responsibleUsersList,
  handleAssignLogisticResponsible,
  handleDeleteLogisticResponsible,
  loadingResponsibleUsersList,
  loadingStates
}: {
  logisticServiceData: IlogisticServiceDetails;
  responsibleUsersList: IResponsibleUserData[];
  handleAssignLogisticResponsible: (user: IbackofficeUserData) => Promise<void>;
  handleDeleteLogisticResponsible: (responsibleId?: number, userName?: string) => Promise<void>;
  loadingResponsibleUsersList: boolean;
  loadingStates: boolean;
}) => {
  const { users } = useUsersState();

  const { firstName, lastName, phone, email, phoneCountry } = logisticServiceData?.requester || {};
  const { id: logisticServiceId } = logisticServiceData;
  const noDataText = 'Sin datos';
  const fullName = `${firstName} ${lastName}`;
  const fullPhoneNumber = `+${phoneCountry?.phoneCode} ${phone}`;

  return (
    <div className="LogisticServiceRequesterInformation">
      <div className="logisticServiceDetailsTab1SectionTitle">Información del solicitante</div>
      <div className="flex items-end gap-4">
        <div className="fieldsContent">
          <div>
            <div className="titleStyle">Nombre del solicitante</div>
            <div className="valueStyle">{fullName ?? noDataText}</div>
          </div>

          <div>
            <div className="titleStyle">Número de contacto</div>
            <div className="valueStyle">{fullPhoneNumber ?? noDataText}</div>
          </div>

          <div>
            <div className="titleStyle">Correo</div>
            <div className="valueStyle">{email ?? noDataText}</div>
          </div>
        </div>
        <BordResponsibleUser
          allUsersList={users}
          logisticServiceId={logisticServiceId}
          responsibleUsersList={responsibleUsersList}
          handleAssignResponsible={handleAssignLogisticResponsible}
          handleDeleteResponsible={handleDeleteLogisticResponsible}
          showResponsibleUsersSkeletonLoader={loadingResponsibleUsersList}
          isLoading={loadingStates}
        />
      </div>
    </div>
  );
};

export default LogisticServiceRequesterInformation;
